import Map from '../../../images/Mapa.png';
import './Coverage.scss';

export default function Coverage() {
	return (
		<section className='coverage fondoCoverPrimary'>
			<div className='container'>
				<div className='text-center text-white pt-5'>
					<p className='display-2 m-0 fs-grey fw-bold'>Cobertura</p>
					<p className='lead pdd-5 pdd-0'>
						Contamos con la experiencia y capacidad para poder desplegar operaciones en
						regiones nuevas, en corto tiempo y con excelente nivel de servicio.
					</p>
				</div>
				<div className='row pb-5'>
					<div className='col-12 col-md-5 col-lg-5 text-white col-l-map'>
						<h3 className='display-6 fs-dark fw-bold'>Oficina Central</h3>
						<div className='d-flex align-items-center list-center'>
							<i className='bi bi-chevron-double-right fs-5 pe-1'></i>
							<p className='fs-4 m-0'>Ciudad de México</p>
							<i className='bi bi-chevron-double-left fs-5 ps-1 d-md-none'></i>
						</div>
						<h3 className='display-6 fs-dark fw-bold'>Oficinas Regionales</h3>
						<div className='d-flex align-items-center list-center'>
							<i className='bi bi-chevron-double-right fs-5 pe-1'></i>
							<p className='fs-4 m-0'>Guadalajara</p>
							<i className='bi bi-chevron-double-left fs-5 ps-1 d-md-none'></i>
						</div>
						<div className='d-flex align-items-center list-center'>
							<i className='bi bi-chevron-double-right fs-5 pe-1'></i>
							<p className='fs-4 m-0'>Pachuca</p>
							<i className='bi bi-chevron-double-left fs-5 ps-1 d-md-none'></i>
						</div>
						<div className='d-flex align-items-center list-center'>
							<i className='bi bi-chevron-double-right fs-5 pe-1'></i>
							<p className='fs-4 m-0'>Cuernavaca</p>
							<i className='bi bi-chevron-double-left fs-5 ps-1 d-md-none'></i>
						</div>
						<div className='d-flex align-items-center list-center'>
							<i className='bi bi-chevron-double-right fs-5 pe-1'></i>
							<p className='fs-4 m-0'>Mérida</p>
							<i className='bi bi-chevron-double-left fs-5 ps-1 d-md-none'></i>
						</div>
						<div className='d-flex align-items-center list-center'>
							<i className='bi bi-chevron-double-right fs-5 pe-1'></i>
							<p className='fs-4 m-0'>Cancún</p>
							<i className='bi bi-chevron-double-left fs-5 ps-1 d-md-none'></i>
						</div>
					</div>
					<div className='col-12 col-md-7 col-lg-7'>
						<img src={Map} alt='Mapa Republica' className='img-fluid img-map' />
					</div>
				</div>
			</div>
		</section>
	);
}
